var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15ZM8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z",
    fill: "#717C8C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.86563 3.5C7.39693 3.5 7.01562 3.88148 7.01562 4.35038C7.01562 4.81886 7.39693 5.2 7.86563 5.2C8.33432 5.2 8.71563 4.81886 8.71563 4.35038C8.71563 3.88148 8.33432 3.5 7.86563 3.5Z",
    fill: "#717C8C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.89914 13C8.34091 13 8.69904 12.6419 8.69906 12.2001L8.6992 6.80001C8.69921 6.35818 8.34104 6 7.89921 6C7.45739 6 7.09922 6.35817 7.09922 6.79999V12.2001C7.09922 12.6419 7.45735 13 7.89914 13Z",
    fill: "#717C8C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.efd763c920df2e60ffc6600655177c02.svg";
export { ForwardRef as ReactComponent };